// Shared responsive helpers. Registered as a GLOBAL mixin in main.js so every
// component/view can use `isMobile` / `isPhone` / `isTablet` in templates and
// script without importing. One consistent breakpoint rule app-wide:
//   isPhone  -> xs  (< 600px)        — single-column, card lists, fullscreen modals
//   isMobile -> smAndDown (< 960px)  — overlay nav drawer, stacked toolbars
//   isTablet -> sm only              — occasionally useful between the two
export default {
  computed: {
    isPhone() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    isTablet() {
      return this.$vuetify.breakpoint.smOnly;
    },
  },
  methods: {
    // Lightweight client-side text filter for the mobile card lists (so they
    // can reuse a view's existing `search` field without each view writing a
    // bespoke filter). Deep-stringifies each record and substring-matches the
    // query — fine for the moderate datasets these screens hold.
    $mobileSearch(items, query) {
      const list = items || [];
      if (!query) return list;
      const q = String(query).toLowerCase();
      return list.filter((it) => {
        try {
          return JSON.stringify(it).toLowerCase().includes(q);
        } catch (e) {
          return true;
        }
      });
    },
  },
};
